export default "<div class=\"description\">{{description}}</div>\n";